import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { sized } from "@/lib/img";

export const CategoryCard = ({ cat, index }) => (
  <Link
    to={`/faqs?category=${cat.slug}`}
    data-testid={`category-card-${cat.slug}`}
    style={{ animationDelay: `${index * 70}ms` }}
    className="rise group relative h-40 sm:h-72 overflow-hidden rounded-sm border border-[#27303E] hover:border-amber-500 active:scale-[0.98] transition-[border-color,transform] duration-200"
  >
    <img src={sized(cat.image, 800)} alt={cat.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D10] via-[#0B0D10]/50 to-transparent" />
    <div className="absolute top-2.5 left-2.5 sm:top-4 sm:left-4 font-mono text-[10px] sm:text-[11px] uppercase tracking-widest bg-[#0B0D10]/80 border border-[#27303E] px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-sm">
      {String(index + 1).padStart(2, "0")}<span className="hidden sm:inline"> / {cat.count} fixes</span>
    </div>
    <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5">
      <h3 className="font-display text-lg sm:text-2xl font-extrabold uppercase leading-none tracking-tight">{cat.name}</h3>
      <p className="hidden sm:block text-sm text-slate-300 mt-2">{cat.tagline}</p>
      <p className="sm:hidden font-mono text-[10px] uppercase tracking-widest text-amber-500 mt-1.5">{cat.count} fixes</p>
      <span className="hidden sm:inline-flex mt-3 items-center gap-1 font-mono text-xs uppercase tracking-widest text-amber-500 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300">
        Browse <ArrowRight size={14} />
      </span>
    </div>
  </Link>
);
